<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

const route = useRoute();

// Most settings pages are forms and read better in a centred, bounded card.
// A canvas is the opposite: it wants every pixel it can get. Rather than
// widening this wrapper for all 24 settings areas, a route opts in with
// `meta: { fullWidth: true }` and gets the chrome removed with it - the card's
// border, radius, shadow and padding are what eat the width at the edges.
const isFullWidth = computed(() => Boolean(route.meta?.fullWidth));
</script>

<template>
  <div
    class="flex flex-col w-full h-full m-0 overflow-auto bg-n-surface-1"
    :class="isFullWidth ? 'p-0' : 'px-4 pb-10 pt-5 sm:px-6 lg:px-8'"
  >
    <div
      class="flex w-full items-start bg-n-solid-1"
      :class="
        isFullWidth
          ? 'h-full max-w-none'
          : 'max-w-6xl mx-auto rounded-2xl border border-n-weak p-4 shadow-sm sm:p-6 lg:p-8'
      "
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>
